import CurrencyNumber from "app/components/CurrencyNumber/CurrencyNumber";
import { FormattedMessage } from "react-intl";
import "./PotentialProfit.scss";

type Props = { profit: number };

const PotentialProfit: React.FC<Props> = ({ profit }) => {
  return (
    <div className="potential-profit-container">
      <span className="potential-profit-container__return">
        <FormattedMessage tagName="span" id="bets-return" />
        <CurrencyNumber
          className="potential-profit-container__value"
          value={profit}
        />
      </span>
    </div>
  );
};

export default PotentialProfit;
